import { optional, string, z } from '@kaiizen/zod-less';

export const ApiProductSupplierSkuSchema = z.object({
  kaiizenSku: string,
  productSupplierId: string,
  sku: string,
  orgProductId: optional(string),
  createdAt: string,
  updatedAt: string,
  archivedAt: optional(string),
});

export const ApiCreateProductSupplierSkuSchema = z.object({
  productSupplierId: string,
  sku: string,
  orgProductId: optional(string),
});

export type ApiProductSupplierSku = z.infer<typeof ApiProductSupplierSkuSchema>;
export type ApiCreateProductSupplierSku = z.infer<typeof ApiCreateProductSupplierSkuSchema>;
